export default __webpack_public_path__ + "static/media/FAQandInfo.3a8c56c4.png";